// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResendOTPApiModel from "../api-model/ResendOTPApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeApiModel(json) {
  return {
          message: json.message,
          request_id: json.request_id
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(ResendOTPApiModel.t_decode(json), "ResendOPEntityMapper copy.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
